"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActivePage = exports.items = void 0;
exports.items = [
    {
        label: 'Eyecons Studio',
        items: [
            {
                name: 'videos',
                label: 'Video\'s',
                permission: 'api.videos.index',
                url: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/videos",
                main: true,
            },
            {
                name: 'playlists',
                label: 'Playlists',
                permission: 'api.playlists.index',
                url: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/playlists",
                main: true,
            },
            {
                name: 'livestreams',
                label: 'Live',
                permission: 'api.livestreams.index',
                url: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/livestreams",
                main: true,
            },
            {
                name: 'channels/analytics',
                label: 'Analytics',
                permission: 'api.analytics.index',
                url: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/channels/analytics",
                main: true,
            },
        ],
    },
    {
        label: 'Monetization',
        items: [
            {
                name: 'vouchers',
                label: 'Vouchers',
                permission: 'ecommerce.vouchers.index',
                url: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/vouchers",
                main: true,
            },
            {
                name: 'subscriptions',
                label: 'Subscriptions',
                permission: 'ecommerce.plans.index',
                url: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/subscriptions",
                pro: true
            },
            {
                name: 'channels/billing',
                label: 'Billing',
                permission: 'ecommerce.billings.index',
                url: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/channels/billing",
            },
        ],
    },
    {
        label: 'Marketing Tools',
        items: [
            {
                name: 'channels/branding',
                label: 'Branding',
                permission: 'api.channels.branding',
                url: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/channels/branding",
                main: false,
            },
            {
                name: 'channels/ads',
                label: 'Video ads',
                permission: 'api.channels.ads',
                url: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/channels/ads",
                main: false,
                pro: true
            },
            {
                name: 'channels/emailcaptures',
                label: 'E-mail capture',
                permission: 'api.emails.index',
                url: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/channels/emailcaptures",
                main: false,
                pro: true
            },
            {
                name: 'channels/messages',
                label: 'Push notifications',
                permission: 'media.messages.store',
                url: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/channels/messages",
                main: false,
                pro: true
            },
        ],
    },
    {
        label: 'Eyecons OTT',
        items: [
            {
                name: 'channels/videowall',
                label: 'Videowall',
                permission: 'api.channels.videowall',
                url: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/channels/videowall",
                main: false,
                pro: false
            },
            {
                name: 'channels/showcase',
                label: 'Showcase',
                permission: 'api.channels.showcase',
                url: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/channels/showcase",
                main: false,
                pro: true
            },
        ],
    },
    {
        label: 'Management',
        items: [
            {
                name: 'settings',
                label: 'Settings',
                permission: 'api.channels.settings',
                url: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/channel",
                main: false,
                admin: false
            },
            {
                name: 'users',
                label: 'Users',
                permission: 'auth.users.index',
                url: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/users",
                main: false,
                admin: true
            },
            {
                name: 'channels',
                label: 'Channels',
                permission: 'api.channels.index',
                url: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/channels",
                main: false,
                admin: true
            },
            // {
            //     name: 'roles',
            //     label: 'Rollen',
            //     permission: 'auth.roles.index',
            //     url: `${process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL}/roles`,
            //     main: false,
            //     admin: true
            // },
        ],
    },
];
var getActivePage = function (active) {
    var page = {};
    exports.items.forEach(function (item) {
        item.items.findBy('name', active);
        var search = item.items.findBy('name', active);
        if (search.name) {
            page = search;
        }
    });
    return page;
};
exports.getActivePage = getActivePage;
